import { useState } from "react";
import styled from "styled-components";
import InputField from "./InputfieldWithDropDown";

const ColorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
    box-sizing: border-box;
`;

const ColorChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const ColorChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: white;
  font-size: 14px;
`;

const ColorPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${(props) => props.color || "#000000"};
`;

const RemoveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #999;
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    color: #000;
  }
`;

const ColorSelector = ({ selectedColors, onChange, placeholder }) => {
  const [inputValue, setInputValue] = useState("");

  const addColor = () => {
    if (inputValue.trim() && !selectedColors.includes(inputValue.trim())) {
      onChange([...selectedColors, inputValue.trim()]);
      setInputValue("");
    }
  };

  const removeColor = (colorToRemove) => {
    onChange(selectedColors.filter((color) => color !== colorToRemove));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addColor();
    }
  };

  return (
    <ColorContainer>
      <InputField
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
      />

      <ColorChips>
        {selectedColors.map((color) => (
          <ColorChip key={color}>
            <ColorPreview color={color} />
            <span>{color}</span>
            <RemoveButton type="button" onClick={() => removeColor(color)}>
              ×
            </RemoveButton>
          </ColorChip>
        ))}
      </ColorChips>
    </ColorContainer>
  );
};

export default ColorSelector;
